<template>
  <div class="navinfo">
    <ul class="navbox">
      <li  v-for="nav in navs" 
      :key="nav.id" 
      :class="(nav.id==0)?'item':'itemflex'">
        <a v-if='nav.type == "show"' href="javascript:;" @mouseover="handleMOver(nav.id)" @mouseleave="handleMleave" v-text="nav.name"></a>
        <router-link v-else custom :to="getToLink(nav)" >
          <!-- <span :class="`iconfont ${nav.icon}`" style="margin-right:3px"></span> -->
          {{ nav.name }}
        </router-link>
      </li>
    </ul>
    
  </div>
</template>

<script>
import { NAV_MODELS, IP_TEST ,NEWCENTERLIST} from '@/config.js'
import { getFindcategory } from '@/request/get.js'
export default {
  name: "Nav",
  components: {
  },
  data() {
    return {
      navs: NAV_MODELS,
      showFlag: false,
      showInfo: [],
	  showInfo1:[],
	  showInfo2:[],
    NEWCENTERLIST,
      IP_TEST
    }
  },
  created() {
    this.dealPlatesForNav();
    // this.getFindcategory();
  },
  mounted() {
  },
  methods: {
    async getFindcategory() {
      let { plates } = this.$store.state;
      let list = plates.filter((item) => '新闻中心' == item.name);
      let uuid = list[0].uuid;
      let result = await getFindcategory(uuid);
      this.showInfo1 = this.dealGetPic(result.data || []);
       this.NEWCENTERLIST.filter(
        (item) =>
        {
          let tmplist = this.showInfo1.filter(
            (itemex) =>item == itemex.CategoryChild.name
          )
          this.showInfo.push(tmplist[0])
        }
          
          
        
      )
      // for(let i = 0; i < this.NEWCENTERLIST.length; i++){
      //   if()
      // }
	  // uuid = list[1].uuid;
    //   result = await getFindcategory(uuid);
    //   this.showInfo2 = this.dealGetPic(result.data || []);
    },
    /**
     * 获取到图片的url
     */
    dealGetPic(arr) {
      let shows = arr.map(item => {
        let pic = item.rows.filter(row => row.picsrc != '' && row.picsrc != null);
        item.picsrc = pic[0]&&pic[0].picsrc;
        return item;
      });
      return shows;
    },
    handleMOver(id) {
    //  this.showInfo = this.showInfo1;
	  this.showFlag = true;
    },
    handleMleave() {
      this.showFlag = false;
    },
    /**
     * navs 同步plates中数据uuid作为请求的url
     */
    dealPlatesForNav() {
      let { plates } = this.$store.state;
      this.navs = this.navs.map((item) => {
        let plate = plates.find(plate => plate.name.replace("T","") == item.name);
        plate&&(item['uuid'] = plate.uuid);
        return item;
      });
      console.log("navs",this.navs);
    },
    getToLink(nav) {
      if (nav.type == "view") {
        return nav.path + (nav.uuid || '未配置nav');
      }
      if (nav.type == "info") {
        return nav.path + (nav.uuid || '未配置nav') +"/000000";
      }
      return nav.path
    },
    changeLink(path) {
      this.handleMleave();
      this.$router.push(path);
    }
  }
};
</script>
<style scoped>
.navinfo{
  position: relative;
  width: 100%;
  height: 56px;
  
background: #004FB7;
  z-index: 2;
  margin-bottom: 20px;
}
.show{
  position: relative;
  margin: 0 auto;
  width: 1300px;
  height: 474px;
  background: #FFFFFF;
  box-shadow: 0px 0px 14px 0px #AEAEAE;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: start;
}
.show>.item{
  margin-top: 31px;
  margin-left: 26px;
  width: 536px;
  height: 178px;
  overflow: hidden;
}
.show>.item>h4{
  width: 72px;
  height: 18px;
  font-size: 18px;

  font-weight: bold;
  color: #333333;
  line-height: 18px;
  margin-bottom: 27px;
  display: inline-block;
}
.show>.item>h4:hover{
  cursor: pointer;
}
.show>.item>.info{
  flex: 1;
  display: flex;
  justify-content: start;
  align-items: start;
}
.show>.item>.info>.list{
  margin-left: 25px;
  margin-top: 5px;
}
.show>.item>.info>.list>li{
  position: relative;
  padding-left:17px;
  margin-bottom: 21px;
  width: 278px;
  height: 16px;
  font-size: 16px;

  font-weight: 500;
  color: #fff;
  line-height: 16px;
  overflow: hidden;
}
.show>.item>.info>.list>li::before{
  position: absolute;
  content: '';
  top:6px;
  left:0px;
  width: 4px;
  height: 4px;
  background: #D8D8D8;
  border-radius: 50%;
}
.navinfo>.navbox>li>a.router-link-exact-active {
  height: 56px;
    background: #0640BA;
    color: red;
    /* border-radius: 8px; */
}
.navinfo>.navbox{
  width: 1300px;
  height: 100%;
  margin: 0 auto;
  text-align: center;
  display: flex;
  justify-content: space-between;
}
.navinfo>.navbox>.item{
  width: 100px;
  height: 100%;
}
.navinfo>.navbox>.itemflex {
  flex: 1;
  height: 100%;
}
.navinfo>.navbox>.item>a,.navinfo>.navbox>.itemflex>a{
  display: inline-block;
  width: 100%;
  height: 100%;
  font-size: 18px;
  
  /* font-weight: bold; */
  color: #fff;
  line-height: 54px;
}
/* .navinfo>.navbox>.itemflex::after{
  content: '';
  padding-left:4px;
  display: inline-block;
  width: 10px;
  height: 8px;
  background: url(/static/img/nav_icon.png) no-repeat center right;
  background-size: 10px 8px;
} */
.show a{
position: relative;
    left: 396px;
    padding-right: 25px;
  /* right: 0; */
  /* top:6px; */
  height: 20px;
  font-size: 14px;

  font-weight: 500;
  color: #B2B2B2;
  line-height: 20px;
  background: url(/static/img/gengduo.png) no-repeat 12px 12px;
  background-position: center right;
  
}
</style>
